<template>
  <div class="typo3LoginContainer">
    <div class="imageCol">
      <img :src="image" alt="login-image" />
    </div>
    <div class="buttonCol">
      <h2>{{ $t('app.loginHeadline') }}</h2>
      <v-btn
        class="btnToKeyCloak btn"
        rounded
        :disabled="buttonDisabled"
        color="primary"
        :elevation="0"
        @click="startLogin"
        >{{ $t('app.login') }}
      </v-btn>
      <v-btn
        v-if="dataOkta"
        class="btnToKeyCloak btn mt-8"
        rounded
        :disabled="buttonDisabled"
        color="primary"
        :elevation="0"
        @click="startLoginOkta"
        >{{ $t('app.loginOkta') }}
      </v-btn>
      <section v-if="dataBrand === 'ua'" class="mt-14">
        <h3 class="mb-2">{{ $t('app.loginBranded.uaNoLogin') }}</h3>
        <p>
          <BaseLink :href="$t('app.loginBranded.uaNoLoginAccessUrl')" target="_blank">{{
            $t('app.loginBranded.uaNoLoginAccessText')
          }}</BaseLink>
        </p>
        <h3 class="mb-2 mt-8">{{ $t('app.loginBranded.uaBecomeDealer') }}</h3>
        <p>
          <BaseLink :href="$t('app.loginBranded.uaDealerRequestUrl')" target="_blank">{{
            $t('app.loginBranded.uaDealerRequestText')
          }}</BaseLink>
        </p>
      </section>
    </div>
  </div>
</template>

<script>
import { isUndefined } from 'lodash-es'
import { mapGetters } from 'vuex'
import APP_MUTATIONS from '@/js/plugins/store/modules/app/mutation-types.js'

import { types as STOREMODULES } from '@/js/plugins/store/store-modules.js'
import APP_GETTER from '@/js/plugins/store/modules/app/getter-types.js'

export default {
  name: 'LoginForm',
  props: {
    dataBrand: {
      type: String,
      default: 'dp',
    },
    dataOkta: {
      type: String,
      default: '',
    },
    dataUmloginurl: {
      type: String,
      default: '',
    },
    // dataRedirecturl: {
    //   type: String,
    //   default: '',
    // },
  },
  data() {
    return {
      buttonDisabled: isUndefined(window?.loginButtonDisabled) ? true : window.loginButtonDisabled,
    }
  },
  computed: {
    ...mapGetters(STOREMODULES.APP, {
      username: APP_GETTER.USERNAME,
      appLogoutUrl: APP_GETTER.LOGOUT_URL,
    }),
    image() {
      return `/fileadmin/login/${this.dataBrand}-login.jpg`
    },
  },
  created() {
    if (this.username) {
      window.location = this.appLogoutUrl
    }
    if (this.dataUmloginurl) {
      this.$store.commit(`${STOREMODULES.APP}/${APP_MUTATIONS.SET_RETURN_ROUTE}`, {
        name: 'dealers',
      })

      window.location = this.dataUmloginurl
    }
    console.log('🚀 ~ file: LoginForm.vue:45 ~ created ~ this.buttonDisabled:', this.buttonDisabled)
    window.addEventListener('changeLoginButton', () => {
      console.log(
        '🚀 ~ file: LoginForm.vue:42 ~ created ~ window.loginButtonDisabled:',
        window.loginButtonDisabled,
      )
      this.buttonDisabled = window.loginButtonDisabled
    })
  },
  methods: {
    startLogin() {
      if ('serviceWorker' in navigator) {
        window.startSSOLoginFlow()
      } else {
        confirm(this.$t('app.serviceWorkerNotSupportedText'))
      }
    },
    startLoginOkta() {
      if ('serviceWorker' in navigator) {
        window.startSSOLoginFlow(false, true) // function(changePassword, bypassKcLoginprompt)
      } else {
        confirm(this.$t('app.serviceWorkerNotSupportedText'))
      }
    },
  },
}
</script>

<style lang="scss" module>
.btnToKeyCloak {
  position: relative;

  // margin: 1rem 0 0 0;

  letter-spacing: 0.0892857143em;
  text-transform: uppercase;

  transition: all 0.28s cubic-bezier(0.4, 0, 0.2, 1);
}
</style>
